<template>
  <div
    class="flex flex-col gap-6 rounded-xl border border-grey-light-200 col-span-1 bg-white shadow-sm h-full overflow-auto"
    :class="[props.class, props.padding ? 'p-6' : 'p-0']"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    class?: string;
    padding?: boolean;
  }>(),
  {
    padding: true,
  },
);
</script>
